// Web module: controls. Controls (L1 compliance core). Entity: control. Links: control_requirement, control_evidence,
// control_policy, control_monitor.
//   /controls            ControlsListPage: In scope / Out of scope, Drata filter rail, bulk scope and owners, CSV
//   /controls/:id        generic detail page plus Readiness, Requirements, Evidence, Policies, Monitoring tests and
//                        Approvals and Risks tabs (the generic Mapped records tab is hidden: these tabs show mappings better)
import { lazyComponent } from '../../lib/lazy'
import type { WebModule } from '../../lib/modules'

export const module: WebModule = {
  routes: [],
  entityOverrides: {
    control: {
      ListPage: lazyComponent(() => import('./ControlsListPage'), 'ControlsListPage'),
      detailTabs: [
        {
          id: 'readiness',
          label: 'Readiness',
          order: 12,
          component: lazyComponent(() => import('./ControlTabs'), 'ReadinessTab'),
        },
        {
          id: 'requirements',
          label: 'Requirements',
          order: 20,
          component: lazyComponent(() => import('./ControlTabs'), 'RequirementsTab'),
        },
        {
          id: 'evidence',
          label: 'Evidence',
          order: 30,
          component: lazyComponent(() => import('./ControlTabs'), 'EvidenceTab'),
        },
        {
          id: 'policies',
          label: 'Policies',
          order: 40,
          component: lazyComponent(() => import('./ControlTabs'), 'PoliciesTab'),
        },
        {
          id: 'tests',
          label: 'Monitoring tests',
          order: 50,
          component: lazyComponent(() => import('./ControlTabs'), 'TestsTab'),
        },
        {
          id: 'risks',
          label: 'Risks',
          order: 55,
          component: lazyComponent(() => import('./RisksTab'), 'RisksTab'),
        },
        {
          id: 'approvals',
          label: 'Approvals',
          order: 60,
          component: lazyComponent(() => import('./ControlTabs'), 'ApprovalsTab'),
        },
      ],
      hideDefaultTabs: ['links'],
    },
  },
}
